import React from 'react';
import Header from '@/components/Header';

interface ClubHeaderProps {
  clubName: string;
  clubHandle: string;
  clubId: string;
}

const ClubHeader: React.FC<ClubHeaderProps> = ({ clubName, clubHandle, clubId }) => {
  const navigationLinks = [
    { label: 'About', href: '#details' },
    { label: 'Events', href: '#events' },
    { label: 'Gallery', href: `/venues/${clubHandle}/gallery` }
  ];

  return (
    <Header
      brandName={clubName}
      brandLink={`/venues/${clubHandle}`}
      navigationLinks={navigationLinks}
      variant="club"
      entityId={clubId}
      entityType="businesses"
      showShare={true}
      showBell={true}
    />
  );
};

export default ClubHeader;
